/**
 * AgentsFlowCanvas - Entry point
 * Wraps CanvasInner with required providers (AgentsFlowProvider + ReactFlowProvider)
 */

import React from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import { AgentsFlowProvider } from '../contexts/AgentsFlowContext';
import CanvasInner from './CanvasInner';

const AgentsFlowCanvas = () => (
  <AgentsFlowProvider>
    <ReactFlowProvider>
      <CanvasInner />
    </ReactFlowProvider>
  </AgentsFlowProvider>
);

export default AgentsFlowCanvas;
